import * as yup from "yup";

import { EMAIL_REGEX } from "src/constants";

export const EnrollNurseSchema = yup.object({
  firstname: yup.string().required("First name is required"),
  lastname: yup.string().required("Last name is required"),
  email: yup
    .string()
    .required("Email is required")
    .test("EmailVerification", "Enter a valid email address", (val) =>
      val ? EMAIL_REGEX.test(val) : false
    ),
  dob: yup
    .string()
    .required("DOB is required")
    .matches(/^\d{4}-\d{2}-\d{2}$/, "DOB is required"),
  gender: yup
    .string()
    .required("Gender is required")
    .oneOf(["Male", "Female", "Other"], "Gender is required"),
  street: yup.string().optional(),
  suite: yup.string().optional(),
  city: yup.string().optional(),
  state: yup.string().optional(),
  zipcode: yup
    .string()
    .optional()
    .test("validZip", "Enter a valid zip code", (value) => {
      if (!value || value.trim() === "") return true; // empty is ok
      return /^\d{5}(-\d{4})?$/.test(value);
    }),
  phone_no: yup
    .string()
    .required("Phone number is required")
    .matches(/^\d{10}$/, "Phone number must be 10 digits"),
  phone_type: yup
    .string()
    .optional()
    .oneOf(["Cell", "Home", "Work"], "Phone type is required"),
  prescribing_doctor: yup
    .string()
    .required("QUTENZA Prescribing Doctor is required"),
  consent: yup
    .boolean()
    .oneOf([true], "You must confirm the consent statement")
    .required("You must confirm the consent statement")
    .default(false),
});
